import React from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { AppContext } from "./context/contextApi";

import Header from "./components/Header";
import ToastContainer from "./components/ToastContainer";
import ScrollToTop from "./components/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";
import Footer from "./components/Footer";
import Feed from "./pages/Feed";
import SearchResult from "./pages/SearchResult";
import VideoDetails from "./pages/VideoDetails";
import Favorites from "./pages/Favorites";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ErrorComponent from "./shared/ErrorComponent";

const AppLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <ScrollToTop />
      {/* add top padding equal to header height (h-14 = 56px) so content doesn't go under fixed header */}
      <div className="flex-grow pt-14">
        <Outlet />
      </div>
      {/* Toast UI */}
      <ToastContainer />
      <Footer />
    </div>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <ErrorComponent />,
      children: [
      { path: "/", element: <Feed /> },
      { path: "/searchResult/:searchQuery", element: <SearchResult /> },
      { path: "/favorites", element: <Favorites /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      // slug route for videos must come last so it doesn't shadow other routes
      { path: "/:slug", element: <VideoDetails /> },
    ],
  },
]);

function App() {
  return (
    <AppContext>
      <HelmetProvider>
        <div className="flex flex-col h-full">
          <RouterProvider router={appRouter} />
        </div>
      </HelmetProvider>
    </AppContext>
  );
}

export default App;
